export default __webpack_public_path__ + "static/media/vijay.103e00d2.png";